import { useLoading } from "crossdock/common/useLoading";

export function useMovePalletLoading() {
  return useLoading();
}
